export const CONSENT_STORAGE_KEY = 'avyna.consent';

/**
 * Raise it on any change to the `consent.*` strings, in any language, and add a row to the
 * banner-versions table in docs/documentation/analytics.md: every stored answer is then asked again.
 */
export const CONSENT_BANNER_VERSION = 1;

/** After this many months either answer lapses and the banner asks again. */
export const CONSENT_LIFETIME_MONTHS = 6;
